<template>
  <div class="page-header-index-wide">
    <div class="outBox">
      <div class="left">
        <div class="l-before">修 复 前</div>
        <div class="firstPic">
          <j-image-upload text="上传需要修复的人脸照片" v-model="picUrl" @change="change"></j-image-upload>
        </div>
        <div class="firstPic">
          <j-image-upload text="上传帮助修复的清晰人脸照片" v-model="picUrl1"></j-image-upload>
        </div>
      </div>

      <div class="middle">
        <img src="@/assets/aver.gif" alt="" class="m-img" v-show="visible" />
        <div class="b-tran" @click="startXf"> {{visible ? '正在修复' : '开始修复'}}</div>
      </div>
      <div class="right">
        <div class="l-after">修 复 后</div>
        <div class="r-firstPic">
          <img
            :src="window._CONFIG['resourceURL'] + '/school/sys/common/downloadSlice?filename=' + rightPicUrl"
            class="r-img"
            v-show="rightPicUrl"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JUpload from '@/components/jeecg/JUpload'
import { getPic } from '@/api/manage'
export default {
  components: { JDictSelectTag, JImageUpload, JUpload },
  data() {
    return {
      visible: false,
      picUrl: '',
      picUrl1: '',
      rightPicUrl: '',
    }
  },
  created() {},
  methods: {
    change(e) {
      this.picUrl = e
    },
    doXf() {
      getPic(window._CONFIG['domianURL'] + '/ddUser/pictureEnhance?picUrl=' + this.picUrl).then((res) => {
        if (res.success) {
          this.rightPicUrl = res.result
          this.visible = false
          clearTimeout(this.timer)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    startXf() {
      if (this.picUrl == '') {
        this.$message.warning('请先上传需要修复的人脸照片')
      } else if (this.picUrl1 == '') {
        this.$message.warning('请先上传帮助修复的清晰人脸照片')
      } else {
        this.visible = true
        var timer = setTimeout(() => {
          this.doXf()
        }, 1000)
      }
    },
  },
}
</script>

<style scoped>
.page-header-index-wide {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 86vh;
  background-image: url('~@/assets/banner.png');
  background-size: cover;
  color: #fff;
}
.outBox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 90%;
  height: 500px;
}
.firstPic,
.r-firstPic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 200px;
  margin: 30px 0;
  background-color: rgba(128, 128, 128, 0.5);
  border-radius: 10px;
}
.r-firstPic {
  height: 430px;
}

.left {
  height: 500px;
  text-align: center;
}
.middle {
  position: relative;
  width: 220px;
  height: 500px;
  text-align: center;
}
.right {
  height: 500px;
  text-align: center;
}
.b-tran {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #489cff;
  font-size: 20px;
  background-image: url('~@/assets/translate.png');
  background-size: 100% 100%;
  cursor: pointer;
}
.l-before,
.l-after {
  font-size: 26px;
  font-weight: 900;
}
.m-img {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  mix-blend-mode: screen;
}
.r-img {
  position: relative;
  width: 260px;
  height: 320px;
  text-align: center;
  mix-blend-mode: screen;
}
/deep/ .ant-upload-picture-card-wrapper {
  display: flex;
  flex-direction: column;
}
/deep/ .ant-upload {
  width: 140px !important;
  height: 160px !important;
  border: none;
  margin: 0 auto;
  background-color: transparent;
  color: #fff;
}
</style>